import React from 'react';
import './Header.css';
import { IoMdSettings } from "react-icons/io";
import { FaArrowLeft } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';
import { CgProfile } from "react-icons/cg";

const Header = ({ heading }) => {
  const navigate = useNavigate();

  const handleProfile = () => {
    navigate('/profile') 
  };

  const handleBack = () => {
    navigate(-1) 
  };

  return (
    <header className="header">
      <button className="back-button" onClick={()=>handleBack()}>
        <FaArrowLeft size={25}/>
      </button>
      <h1 className="heading">{heading}</h1>
      <button className="settings-icon" onClick={handleProfile}>
        <CgProfile size={25} />
      </button>
    </header>
  );
};

export default Header;
